/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedStandartProductConversionFieldRequestDto } from '../../models/backend-patched-standart-product-conversion-field-request-dto';
import { BackendStandartProductConversionFieldDto } from '../../models/backend-standart-product-conversion-field-dto';

export interface SalesStandardProductConversionFieldsPartialUpdate$FormData$Params {
  id: number;
  body?: BackendPatchedStandartProductConversionFieldRequestDto;
}

export function salesStandardProductConversionFieldsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductConversionFieldsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductConversionFieldsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandartProductConversionFieldDto>;
    }),
  );
}

salesStandardProductConversionFieldsPartialUpdate$FormData.PATH = '/api/sales/standard-product-conversion-fields/{id}/';
